import React, { useState, useEffect } from 'react';
import { makeAuthenticatedRequest, getSellerId } from '../../utils/api.js';

const SearchableLocationDropdown = ({ value, onChange }) => {
    const [search, setSearch] = useState('');
    const [options, setOptions] = useState([]);
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!search) {
            setOptions([]);
            return;
        }

        const fetchLocations = async () => {
            setLoading(true);
            try {
                const sellerId = getSellerId();
                const response = await makeAuthenticatedRequest(
                    '/api/seller/irm-material-location-list',
                    { seller_id: sellerId, search_text: search } // optional search_text if your API supports
                );
                console.log(response.data[0].state_name);

                if (response?.data) {
                    // Map API response to {id, name} format for dropdown
                    const mappedOptions = response.data.map((loc) => ({
                        id: loc.area_id,
                        name: `${loc.name}, ${loc.state_name}, ${loc.state_short_code}`,
                        city_name: `${loc.city_name}`,
                        city_id: loc.city_id,
                        state_name: loc.state_name,
                    }));

                    setOptions(mappedOptions);
                } else {
                    setOptions([]);
                }
            } catch (error) {
                console.error('Failed to fetch locations:', error);
                setOptions([]);
            } finally {
                setLoading(false);
            }
        };

        fetchLocations();
    }, [search]);

    return (
        <div className="form-group">
            <label>Material Location</label>
            <input
                placeholder="Search location"
                value={search}
                onFocus={() => setOpen(true)}
                onChange={(e) => setSearch(e.target.value)}
            />
            {open && (
                <div className="dropdown-list">
                    {loading && <div className="dropdown-item muted">Loading...</div>}
                    {!loading && options.length === 0 && (
                        <div className="dropdown-item muted">No results</div>
                    )}
                    {!loading && options.map((loc) => (
                        <div
                            key={loc.id}
                            className="dropdown-item"
                            onClick={() => {
                                onChange(loc.id);
                                setSearch(loc.name);
                                setOpen(false);
                            }}
                        >
                            {loc.name} {`, ${loc.city_name}, ${loc.state_name}, ${loc.id}`}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default SearchableLocationDropdown;
